import React from "react";
import { Grid, Typography } from "@mui/material";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";
import { settings } from "app";
import { Button } from "react-admin";
import CloseIcon from "@mui/icons-material/Close";

const ExamList = ({ exams, validateExamDate, readOnly, onRemoveExam, isClone }) => {
  if (!exams) {
    return null;
  }
  return (
    <>
      {exams
        .sort((a, b) => a.examId - b.examId)
        .map((exam, index) => (
          <Grid
            container
            spacing={2}
            sx={{ ...settings.style.gridContainer, marginLeft: 2, mt: index === 0 ? 2 : 0 }}
            gap={1}
            key={exam.examId}
          >
            <Grid
              item
              xs={12}
              md={2}
            >
              <Typography color={"primary"}>Изпит</Typography>
              <Typography>{exam.name}</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={2.3}
            >
              <CustomDateTimeInput
                source={`examTimestamp${index}`}
                label="Дата и час на изпит"
                defaultValue={exam.examTimestamp}
                validate={validateExamDate}
                required={true}
                readOnly={!isClone && (readOnly || exam.examPassed)}
              />
            </Grid>

            {!exam.examPassed && (
              <Grid
                item
                xs={12}
                md={7}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  label="Премахни"
                  size="medium"
                  color="error"
                  onClick={() => onRemoveExam(index)}
                  disabled={readOnly}
                >
                  <CloseIcon />
                </Button>
              </Grid>
            )}
          </Grid>
        ))}
    </>
  );
};

export default ExamList;
